{
  "features": {
    "config": {
      "title": "Companion of the Lamb",
      "subtitle": "Twitch integration configuration",
      "no-affiliate-or-partner-error": "This feature is only available for Twitch affiliates and partners.",
      "sections": {
        "info": {
          "moreInfo": "For a quick setup guide and overview of the features of this integration, see"
        },
        "totem": {
          "title": "Totem reward",
          "totemSetupPrompt": "You will need to grant the Extension permission to create the Channel Points reward for the in-game Twitch Totem to work.",
          "totemSetupSuccess": "Your totem is set up correctly. To manage the reward cost, go to",
          "channelPointsSettingsLink": "your Channel Points settings page.",
          "actions": {
            "setUpTotem": "Set up Totem"
          }
        },
        "premiumSkins": {
          "title": "Premium follower skins",
          "description": "Using this extension, your viewers will be able to appear in-game as followers. They will be able to customise their followers, including the use of Bits for premium skins. Select the amount of Bits for a premium skin, or you can choose to keep them free to allow anyone to use these skins.",
          "noBitsOption": "No Bits, I want free premium skins for my viewers",
          "bitsFeatureNotAvailable": "Your channel cannot use Bits. Your viewers will be able to select any skin they like without using Bits."
        }
      },
      "actions": {
        "save": "Save changes"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "Join {{channelName}}'s Cult!",
        "subtitle": "You won the raffle!",
        "timeRemaining": "Time remaining: {{time}}",
        "message": "Joining our cult has plenty of advantages: the chance to grow extra demonic appendages, the honor of dedicating every living second to the Cult of the Lamb, and the glory of possibly being sacrificed!",
        "viewerLinkCta": "To enter, please {share your identity}.",
        "existingFollowerMessage": "You have already joined {{channelName}}'s Cult and cannot create a new follower.",
        "actions": {
          "joinRaffle": "I want to join the Cult",
          "joinRaffleViewerHasAlreadyJoined": "You have joined the raffle",
          "dismissRaffle": "No thanks, I'm out",
          "dismissRaffleViewerHasAlreadyJoined": "Close",
          "permanentlyDismissRaffle": "Close and don't show again"
        },
        "raffleJoinedMessage": "Your willingness is appreciated. If you are chosen to join the Cult, you will be informed soon. You may close this window."
      },
      "followerBuilder": {
        "title": "Create your follower",
        "steps": {
          "intro": {
            "message": "You've joined the Cult! The follower you create here will appear in-game. Keep in mind that your follower will eventually die, but at least it was for a greater cause.",
            "actions": {
              "goToNextStep": "Create your follower"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "Continue"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "Back to skins",
              "goToNextStep": {
                "variationsForSkin": "Continue",
                "noVariationsForSkin": "Create my follower"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "Back to colors",
              "goToNextStep": "Create my follower"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "help",
      "hinder": "hinder",
      "hhVotingFlyout": {
        "title": "Help or Hinder",
        "message": "Cast your vote",
        "timeRemaining": "Time remaining: {{time}}",
        "voteCount": "{{amount}} votes"
      },
      "outcomeVotingFlyout": {
        "title": "Cast your vote to {{helpOrHinder}} {{channelName}}",
        "timeRemaining": "Time remaining: {{time}}"
      }
    }
  }
}
